import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import PageTitle from "../pagetitle/PageTitle";
import Footer from "../footer/Footer";
import Scrollbar from "../scrollbar/scrollbar";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ContactUIPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    if (!name || !email || !message) {
      toast.error("Please fill out all fields.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    toast.success("Message sent successfully!", {
      position: "top-right",
      autoClose: 3000,
    });

    // Optional: Clear form after submission
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>
      <Navbar />
      <PageTitle pageTitle="Contact Us" pagesub="Contact" />
      <div className="about-area sm-separator-padding">
        <div className="sm-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-sm-12">
              <div
                className="heading-title text-center mb-4"
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "block",
                }}
              >
                <h2>Contact Us</h2>
                <p>
                  We'd love to hear from you! Please fill out the form below and
                  our team will get back to you as soon as possible.
                </p>
              </div>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="message">Message</label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="5"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div style={{ justifyContent: "flex-end", display: "flex" }}>
                  <button type="submit" className="cart-btn-full w-100">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
      <ToastContainer />
    </>
  );
};

export default ContactUIPage;
